"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scatter_gl_1 = require("./scatter_gl");
exports.ScatterGL = scatter_gl_1.ScatterGL;
var data_1 = require("./data");
exports.Dataset = data_1.Dataset;
